/*
 * @Author: your name
 * @Date: 2021-06-04 09:07:23
 * @LastEditTime: 2021-06-04 15:18:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edity=
 * @FilePath: \element\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import $axios from './request/axios'
import VConsole from 'vconsole'
import VueCookies from "vue-cookies";
import VueClipboard from 'vue-clipboard2'
import {Notification} from 'element-ui'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

// const vconsole = new VConsole()
Vue.prototype.$axios = $axios
Vue.use(Viewer)
Vue.config.productionTip = false
Vue.use(VueCookies);
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


